import { render, staticRenderFns } from "./PlaceholderEventPreviewCard.vue?vue&type=template&id=0b1d00ee&scoped=true&"
import script from "./PlaceholderEventPreviewCard.vue?vue&type=script&lang=js&"
export * from "./PlaceholderEventPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PlaceholderEventPreviewCard.vue?vue&type=style&index=0&id=0b1d00ee&lang=scss&scoped=true&"
import style1 from "./PlaceholderEventPreviewCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d00ee",
  null
  
)

export default component.exports